import {ChangeDetectionStrategy, Component, ViewEncapsulation} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-requests-list-my",
    template: `
        <h1 class="container-heading">My requests</h1>
        <mat-card>
            <mat-card-content>
                <section-requests-list [only_my]="true" [type]="['it','request']"
                                       [state]="state"></section-requests-list>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class RequestsListMyComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "support-requests-my",
            actions: {
                "browse": ["browse_requests"]
            }
        };
    }
}
